const paths = {
  listVehicle: '/vehicle/list',
  editVehicle: '/vehicle/edit'
};

export default paths;
